import { useState, useEffect, useMemo, useCallback, createContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Prompt } from 'react-router-dom';
import moment from 'moment';
import { ButtonBase, FormControlLabel, Checkbox, Button } from '@material-ui/core';
import { DragDropContext } from 'react-beautiful-dnd';
import { updateLoginInfoAction, SetEdit, SetUnEdit } from '../../redux/actions';
import { dutyAssignAPI } from '../../apis';
import rou from '../../router';
import DiaLog from '../../components/Dialog';
import { conditional, downloadFileById, useGetUserInfo } from '../../utils';
import Alert from '../../components/Alert';
import { i18n } from '../../language';
import { authNameE } from '../../utils/userFuncs';
import handleStaffColor from '../../utils/handleStaffColor';
import { PublishIcon, SaveIcon, DateIcon } from '../../components/Icon';
import KeyboardDatePicker from '../../components/keyboardDatePicker';
import CustomAccordion from '../../components/Accordion';
import dt_roster from '../../static/images/dt_roster.png';
import VerifyAccountPop from '../../components/Login/VerifyAccountPop';
import { alertMsg } from '../../apis/commlogic';
import { Header, DutyIC, OnDuty, DutyRoster, Footnote, Leave } from './components';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
  },
  body: {
    padding: '2.125rem 0 0 3.375rem',
    background: theme.palette.bodyBG,
    position: 'relative',
    minHeight: '100vh',
    marginTop: '2.5rem',
    paddingBottom: '3.125rem',
    '&>div:first-child': {
      border: '0',
    },
  },
  savedAlert: {
    margin: '0 0 -0.5rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    letterSpacing: 0,
    color: theme.palette.font.sub,
    fontWeight: 500,
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1.25rem',
    height: '3rem',
    alignItems: 'center',
    paddingRight: '3.563rem',
  },
  headButton: {
    // width: '8.875rem',
    width: '8.5rem',
    border: 'solid 1px #538fff',
    height: '3rem',
    borderRadius: '10px',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: '500',
    color: theme.palette.primary.main,
    // padding: '0 2.5rem 0 1.625rem',
    padding: '0 .7rem',
  },
  batchPublishButton: {
    // width: '8.875rem',
    width: '10.25rem',
    border: 'solid 1px #538fff',
    height: '3rem',
    borderRadius: '10px',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: '500',
    color: theme.palette.primary.main,
    // padding: '0 2.5rem 0 1.625rem',
    padding: '0 .7rem',
  },
  saveIcon: {
    fontSize: '1.125rem',
    color: theme.palette.primary.main,
    // marginRight: '1.25rem',
    marginRight: '.5rem',
  },
  publishIcon: {
    fontSize: '1.375rem',
    color: theme.palette.primary.main,
    marginRight: '.5rem',
  },
  notSaveBody: {
    color: theme.palette.font.main,
    fontSize: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 500,
    lineHeight: '1.875rem',
  },
  rosterPng: {
    width: '9.375rem',
    height: 'auto',
  },
  rosterBody: {
    width: '100%',
    height: 'calc(100vh - 4.375rem)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: '19.438rem',
    flexDirection: 'column',
  },
  rosterContent: {
    marginTop: '1.25rem',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: '#707090',
    fontWeight: '600',
  },
  publishBody: {
    color: theme.palette.font.main,
    fontSize: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    lineHeight: '1.875rem',
  },
  searchButton: {
    textTransform: 'capitalize',
    width: '5.5rem',
    height: '3.25rem',
    borderRadius: '0.5rem',
    backgroundColor: '#4c93ff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: '#FFFFFF',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
    '&:disabled': {
      backgroundColor: '#c0c6cb !important',
      color: '#ffffff !important',
    },
  },
  redCorner: {
    position: 'absolute',
    right: 0,
    top: 0,
    border: 'solid',
    borderTopWidth: 4,
    borderRightWidth: 4,
    borderLeftWidth: 4,
    borderTopColor: 'red',
    borderLeftColor: 'transparent',
    borderRightColor: 'red',
    borderBottomColor: 'transparent',
  },
  blueItem: {
    position: 'relative',
    width: 25,
    height: 20,
    borderRadius: 4,
    marginRight: 5,
    backgroundColor: '#538fff',
  },
  infoMessageView: {
    marginTop: '0.625rem',
    marginLeft: '0.1rem',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'start',
  },
  messageItem: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
  },
  messageText: {
    color: '#333',
    fontSize: '0.9rem',
    fontStyle: 'italic',
  },
  Picon: {
    color: '#538fff',
  },
}));

export const DutyContext = createContext(null);

const DutyAssign = ({
  loginInfo,
  setUpLogin,
  wardId,
  hospitalId,
  history,
  roleMap,
  editFlag,
  setEdit,
  setUnEdit,
  rouList,
}) => {
  const { flag: isLogin } = loginInfo;
  const classes = useStyles();
  const [dutyInfo, setDutyInfo] = useState(null);
  const [noteList, setNoteList] = useState([]);
  const [notifyList, setNotifyList] = useState();
  const [staffList, setStaffList] = useState([]);
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [alertInfo, setAlertInfo] = useState(null);
  const [staffsList, setStaffsList] = useState(null);
  const publishCtrl = roleMap[authNameE.dutyAssign_Update_Save_Publish_Notify];
  const userInfo = useGetUserInfo();
  const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
  const [rosterId, setRosterId] = useState(dutyDateInfo?.id ?? -1);
  const rosterDate = dutyDateInfo?.date ?? moment();
  const [publishOpen, setPublishOpen] = useState(false);
  const [rosterRefresh, setrosterRefresh] = useState(false);
  const [publishInfo, setPublishInfo] = useState({
    draftBy: null,
    draftDate: null,
    draftStatus: null,
    publishBy: null,
    publishDate: null,
    version: null,
    isSort: 0,
  });
  const [savePopup, setSavePopup] = useState(false);
  const [publishPopup, setPublishPopup] = useState(false);
  const [lastEditor, setLastEditor] = useState('');
  const [isRosterName, setIsRosterName] = useState(0);
  const [enableSmartComm, setEnableSmartComm] = useState(false);
  const [hasLinkedChatroomDeleted, setHasLinkedChatroomDeleted] = useState(false);
  const [rankOrderMap, setRankOrderMap] = useState(null);
  const [dutyCheckList, setDutyCheckList] = useState([]);
  const [isQuickClockIO, setIsQuickClockIO] = useState(0);
  const [hiddenRoster, setHiddenRoster] = useState(false);
  const [hasDutyChatValue, setHasDutyChatValue] = useState(false);
  
  const handleEdit = useCallback(() => {
    setEdit();
  }, []);

  // 修改更表
  const handleEditDuty = (dutyTemplateGroupId) => (callback) => {
    setDutyInfo((preDuty) => {
      return {
        ...preDuty,
        dutyGroups: _.map(preDuty.dutyGroups, (item) => {
          return item.dutyTemplateGroupId === dutyTemplateGroupId
            ? { ...item, dutyAreas: _.isFunction(callback) ? callback(item.dutyAreas) : callback }
            : item;
        }),
      };
    });
  };

  // 获取 isRosterName
  const getIsRosterNameDetail = async () => {
    try {
      const { result: rosterNameDeatilResult } = await dutyAssignAPI.getIsRosterNameDetail({
        dutyTemplateRosterId: rosterId,
      });
      setIsRosterName(rosterNameDeatilResult.isRosterName ? 1 : 0);
      setIsQuickClockIO(rosterNameDeatilResult.isQuickClockIO);
      getCheckListAPI(rosterNameDeatilResult.isQuickClockIO);
      setEnableSmartComm(rosterNameDeatilResult.isSmartCommunication === 1 ? true : false);
   
    } catch (error) {
      console.log(error);
    }
  };

  const getCheckListAPI = useCallback(
    (isQuick = isQuickClockIO) => {
      if (isQuick === 1 && isCheckDate(rosterDate)) {
        fetchCheckList(rosterId);
      } else {
        setDutyCheckList([]);
      }
    },
    [isQuickClockIO, rosterId]
  );

  // duty API
  const getDutyListAPI = useCallback(async () => {
    if (rosterId === -1) return;
    try {
      setPublishInfo({
        draftBy: null,
        draftDate: null,
        draftStatus: null,
        publishBy: null,
        publishDate: null,
        version: null,
        isSort: 0,
      });
      setDutyInfo(null);
      const { result } = await dutyAssignAPI.getDaDutyList({
        templateRosterId: rosterId,
        wardId,
        userId: loginInfo.userId,
      });
      setPublishInfo({
        draftBy: result.draftBy,
        draftDate: result.draftDate,
        draftStatus: result.draftStatus,
        publishBy: result.publishBy,
        publishDate: result.publishDate,
        version: result.version,
        isSort: result.isSort ?? 0,
      });
      const newDutyInfo = initDutyInfo(result.daDutyInfo ? result.daDutyInfo : result.templateInfo);
      setDutyInfo(newDutyInfo);
      setHasDutyChatValue(hasAnyDutyChatTime(newDutyInfo));
      setSavePopup(false);
      setPublishPopup(false);
      // 获取 isRosterName
      getIsRosterNameDetail();
      setHiddenRoster(result.hidden === 1 ? true : false);
    } catch (error) {
      console.log('-----Duty error----->', error);
    }
  }, [rosterId, wardId, loginInfo.userId]);

  const resetStaffList = ({ name, group, timeStart, timeEnd }) => {
    if (name === '' && group === '' && timeStart === '' && timeEnd === '') {
      setStaffList([]);
    }
  };

  // roster API
  const getStaffListAPI = useCallback(
    async ({ name = '', group = '', timeStart = '', timeEnd = '' }) => {
      try {
        resetStaffList({ name, group, timeStart, timeEnd });
        const { result } = await dutyAssignAPI.getDaStaffList({
          wardId,
          date: rosterDate ? moment(rosterDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
          name: conditional(name, name, ''),
          group: conditional(group, group, ''),
          timeStart: conditional(timeStart, timeStart, ''),
          timeEnd: conditional(timeEnd, timeEnd, ''),
        });
        setRankOrderMap(result.rankOrder);
        setStaffsList([...result.tempStaff, ...result.srsStaff]);
        if (name === '' && group === '' && timeStart === '' && timeEnd === '') {
          setStaffList(
            _.map([...result.srsStaff, ...result.tempStaff], (item) => {
              return {
                ...item,
                temporary: Boolean(item.tempId),
                remark: item.remark_cat,
                longremark: item.remark,
                outlineColour: (item.role && handleStaffColor({ role: item.role })) ?? 0,
                name: item.staff_name,
                srsUnitCode: item.unit_code,
                srsRankCode: item.rank_code,
                srsShiftCode: item.shift_code,
                corpId: item.corpId,
                tempId: item.tempId,
                id: item.corpId ?? item.tempId ?? item.staff_name ?? null,
                publishCtrl: publishCtrl,
                staff: true,
                startDate: item.start_date,
                endDate: item.end_date,
                rankCode: item.rank_code,
                role: item.role,
                rankOrder: item.rank_order,
                Rinfo: {
                  corpId: item.corpId,
                  empId: item.emp_id,
                  staffName: item.staff_name,
                  tempUserId: item.tempId,
                },
              };
            })
          );
        }
      } catch (error) {
        console.log('-----Duty Roster error----->', error);
      }
    },
    [wardId, rosterDate, publishCtrl]
  );

  // reset API
  const getResetDutyAPI = useCallback(async () => {
    try {
      (async () => {
        await getStaffListAPI({});
      })();
      const { result } = await dutyAssignAPI.getResetDuty({
        templateRosterId: rosterId,
        wardId,
      });
      setDutyInfo(
        initDutyInfo({
          ...(result.daDutyInfo ? result.daDutyInfo : result.templateInfo),
          dutyRosterId: dutyInfo.dutyRosterId,
        })
      );
      setNoteList([...result.footNoteInfo]);
      handleEdit();
      setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_RESET_SUCCESS_ALERT'), type: 'success' });
    } catch (error) {
      console.log('-----Reset Duty error----->', error);
    }
  }, [getStaffListAPI, rosterId, wardId, dutyInfo?.dutyRosterId]);

  // footnote API
  const getFootNoteAPI = useCallback(
    async (notes = []) => {
      try {
        if (rosterId !== -1) {
          const { result } = await dutyAssignAPI.getDaFootNote({ templateRosterId: rosterId });
          const mergeNoteList = notes
            .filter((el) => el.id !== null && el.id < 0)
            .map((el, eli) => ({
              dutyFootnoteId: el.id,
              footnoteName: el.name,
              order: eli + 1,
              ...el,
            }))
            .concat(result);
          setNoteList(mergeNoteList);
        }
      } catch (error) {
        console.log('-----FootNote error----->', error);
      }
    },
    [rosterId]
  );

  const handleReOrderFootNoteAPI = useCallback(
    async (props) => {
      try {
        await dutyAssignAPI.postReOrderFootNote({ footNoteOrders: props });
        await getFootNoteAPI();
      } catch (error) {
        console.log('-----Order FootNote error----->', error);
      }
    },
    [getFootNoteAPI]
  );

  // Export API
  const getExportAPI = useCallback(async () => {
    try {
      if (JSON.stringify(dutyInfo) === '{}') {
        setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_EXPORT_ALERT'), type: 'warning' });
        return;
      }
      if (!publishInfo.publishDate) {
        setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_EXPORT_ALERT_NOT_PUBLISH'), type: 'warning' });
        return;
      }
      await downloadFileById(
        () => {
          return dutyAssignAPI.getDaExportRequest({
            wardId: wardId,
            templateRosterId: dutyInfo.dutyTemplateRosterId,
          });
        },
        () => {
          return `Duty Assign Export Excel_${moment().valueOf()}`;
        }
      );
    } catch (error) {
      console.log('-----Export error----->', error);
    }
  }, [dutyInfo, wardId]);

  // get Notifications API
  const getNotifyStaffAPI = useCallback(async () => {
    try {
      if (!publishInfo.publishDate) {
        setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_NOTIFY_ALERT'), type: 'warning' });
        return;
      }
      setNotifyOpen(true);
      const { result } = await dutyAssignAPI.getNotifications({ templateRosterId: dutyInfo.dutyTemplateRosterId });
      setNotifyList([...result]);
    } catch (error) {
      console.log('-----Get Notify Staff error----->', error);
    }
  }, [dutyInfo]);

  // push Notifycations API
  const pushNotifyStaffAPI = useCallback(async ({ corpInfos, dutyDate, wardName, hospitalCode, wardId }) => {
    try {
      const { result } = await dutyAssignAPI.postPushNotify({
        corpInfos,
        dutyDate,
        wardName,
        hospitalCode,
        wardId,
      });
      setNotifyList([...result]);
      setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_NOTIFY_SUCCESS'), type: 'success' });
    } catch (error) {
      console.log('-----Push Notify Staff error----->', error);
    }
  }, []);

  const isCheckDate = (date = rosterDate) =>
    moment(moment(date)).isBetween(moment().add(-2, 'd'), moment().add(2, 'd'));

  const fetchCheckList = (templateRosterId = rosterId) => {
    if (templateRosterId !== -1) {
      dutyAssignAPI
        .getDaCheckList({
          templateRosterId,
        })
        .then((res) => {
          setDutyCheckList(res.result);
        });
    }
  };

  const hasAnyDutyChatTime = (dutyInfo) => {
    if (!dutyInfo || !Array.isArray(dutyInfo.dutyGroups)) return false;

    const hasChatTimeOrShift = (area) => {
        const {
          chatStartAt,
          chatEndAt,
          chatBufferEnterAt,
          chatBufferLeaveAt,
          dutyChats = [],
          dutyStaffs = [],
        } = area;

      // check chat-related fields
      const hasChat =
        chatStartAt !== null && chatStartAt !== undefined ||
        chatEndAt !== null && chatEndAt !== undefined ||
        chatBufferEnterAt !== null && chatBufferEnterAt !== undefined ||
        chatBufferLeaveAt !== null && chatBufferLeaveAt !== undefined ||
        (Array.isArray(dutyChats) && dutyChats.length > 0);

      // check staff shift fields
      const hasShift = dutyStaffs.some(staff =>
        (staff.shift_date && staff.shift_date !== '') ||
        (staff.shift_start_time && staff.shift_start_time !== '') ||
        (staff.shift_end_time && staff.shift_end_time !== '')
      );

      return hasChat || hasShift;
    };

    return dutyInfo.dutyGroups.some(group =>
      Array.isArray(group.dutyAreas) && group.dutyAreas.some(hasChatTimeOrShift)
    );
  };


  const clockHandler = (status, corpId, tempId, staffName) => {
    (async () => {
      await doClock(status, corpId, tempId, staffName, 'PRE');
    })();
  };

  const doClock = (status, corpId, tempId, staffName, action) => {
    let isToday = '';
    if (moment(rosterDate).format('YYYY-MM-DD') === moment().add('1', 'd').format('YYYY-MM-DD')) {
      isToday = '-';
    } else if (moment(rosterDate).format('YYYY-MM-DD') === moment().add('-1', 'd').format('YYYY-MM-DD')) {
      isToday = '+';
    }

    if (status === 0) {
      (async () => {
        await clockAPI(moment().format(`hh:mm${isToday} a`), null, corpId, tempId, staffName, action, status);
      })();
    } else if (status === 1) {
      (async () => {
        await clockAPI(null, moment().format(`hh:mm${isToday} a`), corpId, tempId, staffName, action, status);
      })();
    }
  };

  const clockAPI = async (clockInTime, clockOutTime, corpId, tempId, staffName, action, status) => {
    try {
      let payload;
      if (clockOutTime === null) {
        payload = {
          checkinTime: clockInTime,
          templateRosterId: rosterId,
          corpId: corpId,
          dutyTempUserId: tempId,
          staffName: staffName,
          action,
          status
        };
      } else if (clockInTime === null) {
        payload = {
          checkoutTime: clockOutTime,
          templateRosterId: rosterId,
          corpId: corpId,
          dutyTempUserId: tempId,
          staffName: staffName,
          action,
          status
        };
      } else {
        payload = {
          checkinTime: clockInTime,
          checkoutTime: clockOutTime,
          templateRosterId: rosterId,
          corpId: corpId,
          dutyTempUserId: tempId,
          staffName: staffName,
          action,
          status
        };
      }
      console.log(payload);
      dutyAssignAPI.saveCheckInOut(payload).then((res) => {
        const { result } = res;
        switch (result) {
          case 'success':
            fetchCheckList();
            break;
          case 'login':
            setVertifyInfo({ corpId, status, tempId, staffName });
            setTimeout(() => {
              try {
                document.querySelector('input[type=password]').focus();
              } catch (e) {
                console.error(e);
              }
            }, 500);
            break;
          case 'confirm':
            setClockInfo({
              clockInTime: clockInTime,
              clockOutTime: clockOutTime,
              corpId: corpId,
              tempId: tempId,
              staffName: staffName,
            });
            setClockConfirmOpen(true);
            break;
          default:
            break;
        }
      });
    } catch (error) {
      console.log('-----Update CheckInOut error----->', error);
    }
  };

  useEffect(() => {
    dutyAssignAPI.getSettingDetail().then((res) => {
      rolePermissions.current = res.result;
    });
  }, []);

  const hanelCheckio = (action, request) => {
    switch (action) {
      case 'ci':
        clockHandler(0, request.corpId, request.tempId, request.name);
        break;
      case 'co':
        clockHandler(1, request.corpId, request.tempId, request.name);
        break;
      default:
        break;
    }
  };

  const handleBrowser = (action, request) => {
    if (action === 'reload') {
      const path = window.location.pathname;
      history.push(rou.homeRou.path);
      history.push(path);
    }
  };

  useEffect(() => {
    if (dutyDateInfo && rosterId !== -1) {
      const hangdleWindowMessage = (event) => {
        const { topic, action, request } = event.data;
        switch (topic) {
          case 'browser':
            handleBrowser(action, request);
            break;
          case 'checkio':
            hanelCheckio(action, request);
            break;
          default:
            break;
        }
      };

      window.addEventListener('message', hangdleWindowMessage, false);
      (async () => {
        await getDutyListAPI();
      })();
      return () => {
        window.removeEventListener('message', hangdleWindowMessage);
      };
    }
  }, [rosterId]);

  useEffect(() => {
    setSavePopup(false);
    setPublishPopup(false);
    setDutyInfo(null);
    setRosterId(-1);
  }, [rouList]);

  const checkDuty = useCallback(() => {
    return dutyInfo === null || JSON.stringify(dutyInfo) === '{}';
  }, [dutyInfo]);

  useEffect(() => {
    getFootNoteAPI();
  }, [getFootNoteAPI]);

  useEffect(() => {
    if (dutyInfo) {
      setHasDutyChatValue(hasAnyDutyChatTime(dutyInfo));
    }
  }, [dutyInfo]);

  const note = useMemo(() => {
    let footlist = [];

    if (JSON.stringify(dutyInfo) === '{}') {
      return footlist;
    }

    if (Array.isArray(noteList) && noteList.length > 0) {
      footlist = _.map(noteList, (item) => {
        return {
          id: item.dutyFootnoteId,
          rosterId: item.dutyRosterId,
          name: item.footnoteName,
          text: item.footnoteDesc,
          pin: item.pin === 1,
          type: item.type,
        };
      });
    }
    return footlist;
  }, [noteList]);

  const checkVersion = useCallback(
    async (publish) => {
      try {
        const { result } = await dutyAssignAPI.getVersion({ templateRosterId: rosterId });
        setLastEditor(publish ? result.publishBy : result.draftBy);
        return result.version === publishInfo.version;
      } catch (error) {
        console.log(error);
        throw new Error('get version error');
      }
    },
    [rosterId, publishInfo]
  );

  const updateParams = useCallback(() => {
    console.log('updateParams');
    if (checkDuty()) {
      return;
    }

    // 检查 duty IC 不能为空
    let dutyICGroup = dutyInfo.dutyGroups.find((item) => String(item.groupType) === '1');
    console.log('dutyICGroup', dutyICGroup);
    if (_.some(dutyICGroup?.dutyAreas, (item) => !item.dutyStaffs[0].name)) {
      setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_PUBLISH_ALERT'), type: 'warning' });
      return;
    }

    // 根据dutyIc的值缓存到localstorage
    let dutyIcStorage = JSON.parse(localStorage.getItem('dutyIC'));
    if (!dutyIcStorage || Array.isArray(dutyIcStorage)) {
      dutyIcStorage = {};
    }
    _.forEach(dutyICGroup?.dutyAreas, (item) => {
      const tempName = item.areaName ?? item.functionalAreaName;
      dutyIcStorage[tempName] = item.dutyStaffs[0];
    });
    localStorage.setItem('dutyIC', JSON.stringify(dutyIcStorage));

    return {
      dutyTemplateRosterId: dutyInfo.dutyTemplateRosterId,
      dutyRosterId: dutyInfo.dutyRosterId,
      dutyGroups: _.map(dutyInfo.dutyGroups, (item, index) => {
        switch (item.groupType) {
          case 1:
            return {
              ...item,
              dutyAreas: _.map(item.dutyAreas, (groupItem) => ({
                ...groupItem,
                areaName: groupItem.areaName ?? groupItem.functionalAreaName,
              })),
              groupOrder: index,
            };
          case 2:
          case 3:
            return { ...item, dutyAreas: _.map(item.dutyAreas, handleUpdate), groupOrder: index };
          default:
            return item;
        }
      }),
      isSort: publishInfo.isSort,
    };
  }, [checkDuty, dutyInfo, publishInfo]);

  // updateAPI
  const updateDutyAPI = useCallback(async () => {
    try {
      const params = updateParams();
      if (!params) {
        return;
      }
      await dutyAssignAPI.postUpdateDaDuty(params);
      setUnEdit();
      setPublishOpen(false);
      setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_PUBLISH_SUCCESS_ALERT'), type: 'success' });
      setPublishPopup(false);
      setTimeout(() => {
        window.postMessage({
          topic: 'browser',
          action: 'reload',
        });
      }, 1000);
    } catch (error) {
      console.log('-----Update Duty error----->', error);
    }
  }, [updateParams]);

  const handleSave = useCallback(async () => {
    try {
      const params = updateParams();
      if (!params) {
        return;
      }
      // andy add, filter chatroom if had been deleted
      const { result } = await dutyAssignAPI.getDropDownLists({
        wardId: loginInfo.wardId,
        hospId: loginInfo.hospId,
      });

      params.dutyGroups.map((dutyGroup) => {
        return dutyGroup.dutyAreas?.map((dutyArea) => {
          const chats = dutyArea.dutyChats?.filter((item) => {
            const exist = result?.chatroom?.findIndex((chatroom) => {
              return chatroom.value === item.chatId;
            });
            if (exist === -1) {
              setHasLinkedChatroomDeleted(true);
            }
            return exist !== -1;
          });
          dutyArea.dutyChats = chats;
          return dutyArea;
        });
      });
      // end

      await dutyAssignAPI.saveDraft({ draft: params, version: publishInfo.version });

      setUnEdit();
      await getDutyListAPI();
      setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_SAVE_SUCCESS_ALERT'), type: 'success' });
    } catch (error) {
      console.log(error);
    }
  }, [updateParams, publishInfo.version]);

  const handleOverride = useCallback(async () => {
    try {
      const params = updateParams();
      if (!params) {
        return;
      }
      await dutyAssignAPI.overrideDraft(params);
      setUnEdit();
      setSavePopup(false);
      await getDutyListAPI();
      setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_SAVE_SUCCESS_ALERT'), type: 'success' });
    } catch (error) {
      console.log(error);
    }
  }, [updateParams, getDutyListAPI]);

  const rosterData = useMemo(() => {
    let tempList = [];
    if (Array.isArray(staffsList)) {
      tempList = _.map(staffsList, (item) => {
        return {
          ...item,
          temporary: Boolean(item.tempId),
          shortRemark: item.remark_cat,
          longRemark: item.remark,
          outlineColour: (item.role && handleStaffColor({ role: item.role })) ?? 0,
          name: item.staff_name,
          srsUnitCode: item.unit_code ?? null,
          srsRankCode: item.rank_code ?? null,
          srsShiftCode: item.shift_code ?? null,
          corpId: item.corpId ?? null,
          tempId: item.tempId ?? null,
          id: item.tempId ?? item.staff_key ?? item.corpId ?? 
             `${item?.staff_name ?? ''}_${item?.rank_order ?? ''}_${item?.unit_code ?? ''}_${item?.shift_code ?? ''}`,
          publishCtrl: publishCtrl,
          staff: true,
          startDate: item.start_date ?? null,
          endDate: item.end_date ?? null,
          rankCode: item.rank_code ?? null,
          role: item.role ?? null,
          rankOrder: item.rank_order ?? null,
          Rinfo: {
            corpId: item.corpId,
            date: moment(rosterDate)?.format('YYYY-MM-DD'),
            empId: item.emp_id,
            staffName: item.staff_name,
            tempUserId: item.tempId,
          },
        };
      });
    }

    const orderList = _.orderBy(tempList, ['temporary', 'rankOrder', 'name'], ['asc', 'asc', 'asc']);

    return orderList;
  }, [staffsList, rosterRefresh, publishCtrl]);

  const checkDragEnd = (e) => {
    return !e.destination;
  };

  // 排序
  const handleDragEnd = useCallback(
    (e) => {
      if (checkDragEnd(e)) {
        return;
      }

      if (e.source.droppableId === 'roster') {
        dragFromRoster(e, setDutyInfo, rosterData, handleEdit, rankOrderMap);
      } else {
        dragFromCubicle(e, setDutyInfo, handleEdit);
      }
    },
    [rosterData]
  );

  const editCW = useMemo(() => {
    if (publishInfo.draftStatus === 0) {
      return i18n.t('DUTYASSIGN_SAVED_TITLE', {
        date: moment(publishInfo.draftDate).format('YYYY-MM-DD HH:mm'),
        name: publishInfo.draftBy,
      });
    } else if (publishInfo.draftStatus === 1) {
      return i18n.t('DUTYASSIGN_PUBLISH_TITLE', {
        date: moment(publishInfo.publishDate).format('YYYY-MM-DD HH:mm'),
        name: publishInfo.publishBy,
      });
    } else {
      if (publishInfo.publishDate) {
        return i18n.t('DUTYASSIGN_PUBLISH_TITLE', {
          date: moment(publishInfo.publishDate).format('YYYY-MM-DD HH:mm'),
          name: publishInfo.publishBy,
        });
      }
      return i18n.t('DUTYASSIGN_PUBLISH_TITLE_DEFAULT');
    }
  }, [publishInfo, i18n.t()]);

  const closeAlertInfo = () => setAlertInfo(null);

  const handlePreSave = useCallback(() => {
    (async () => {
      try {
        if (await checkVersion()) {
          await handleSave();
        } else {
          setSavePopup(true);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [checkVersion, handleSave]);

  const initPublishDialog = { open: false, type: 'single', dateFrom: null, dateTo: null, rosterName: '' };
  const [publishDialog, setPublishDialog] = useState(initPublishDialog);
  const handlePublishDialogClose = () => setPublishDialog(initPublishDialog);
  const [selectAll, setSelectAll] = useState(true);
  const [startMinDate, setStartMinDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [endMinDate, setEndMinDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [endMaxDate, setEndMaxDate] = useState(moment(new Date()).add(2, 'months').endOf('month').format('YYYY-MM-DD'));
  const [confirmDisabled, setConfirmDisabled] = useState(false);
  const [searchDisabled, setSearchDisabled] = useState(true);
  const [publishDialogConfirmOpen, setPublishDialogConfirmOpen] = useState(false);
  const [vertifyInfo, setVertifyInfo] = useState(false);
  const rolePermissions = useRef({});
  const [clockConfirmOpen, setClockConfirmOpen] = useState(false);
  const [clockInfo, setClockInfo] = useState(null);
  useEffect(() => {
    if (publishDialog?.summaryInfo?.selectedTemplateRosterIds?.length > 0) {
      setConfirmDisabled(false);
    } else {
      setConfirmDisabled(true);
    }

    if (publishDialog.dateFrom && publishDialog.dateTo) {
      const toDate = moment(publishDialog.dateTo).endOf('day');
      const toMaxDate = moment(publishDialog.dateFrom).add(2, 'months').endOf('month');
      const toMinDate = moment(publishDialog.dateFrom).startOf('day');
      if (toDate < toMinDate || toDate > toMaxDate) {
        setSearchDisabled(true);
      } else {
        setSearchDisabled(false);
      }
    } else {
      setSearchDisabled(true);
    }
  }, [publishDialog]);
  const handlePrePublishByPeriod = () => {
    const rosterListDom = document
      .querySelector('.duty-assign-header-roster-list')
      .querySelector('.MuiInputBase-input.MuiInputBase-inputMultiline');
    const rosterName = rosterListDom.value;

    const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
    const filterDate = dutyDateInfo.date;
    const dstart = new Date(filterDate);
    setStartMinDate(moment(dstart).format('YYYY-MM-DD'));
    setEndMinDate(moment(dstart).format('YYYY-MM-DD'));
    setEndMaxDate(moment(dstart).add(2, 'months').endOf('month').format('YYYY-MM-DD'));
    dstart.setHours(0, 0, 0, 0);
    const from = dstart.getTime();
    const payload = {
      rosterName,
      from,
    };
    dutyAssignAPI.listDraftSummary(payload).then((res) => {
      const summaryInfo = res.result.summaryInfo;
      const dateTo = new Date(summaryInfo.to).toISOString();
      setPublishDialog({
        ...publishDialog,
        dateFrom: filterDate,
        dateTo,
        open: true,
        // rosterName: ` - (${rosterName})`,
        rosterName: rosterName,
        summaryInfo,
      });
      setSelectAll(true);
    });
  };

  const handlePublishDialogConfirmButtonClick = () => {
    setPublishDialogConfirmOpen(false);
    dutyAssignAPI.publishDraftSummary(publishDialog.summaryInfo).then((res) => {
      if (res?.statusCode === '0') {
        setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_PUBLISH_SUCCESS_ALERT'), type: 'success' });
        handlePublishDialogClose();
        setTimeout(() => {
          window.postMessage({
            topic: 'browser',
            action: 'reload',
          });
        }, 1000);
      }
    });
  };

  const handleSelectAllChange = () => {
    let selectedTemplateRosterIds = [];
    publishDialog.summaryInfo.monthDrafts?.map((monthDraft) => {
      monthDraft.dayDrafts.map((dayDraft) => {
        if (!selectAll) {
          selectedTemplateRosterIds.push(dayDraft.templateRosterId);
        }
        dayDraft.checked = selectAll ? false : true;
        return dayDraft;
      });
      return monthDraft;
    });
    publishDialog.summaryInfo.selectedTemplateRosterIds = selectedTemplateRosterIds;
    setSelectAll(!selectAll);
    setPublishDialog({ ...publishDialog });
  };

  const handleDayItemClick = (item) => {
    publishDialog.summaryInfo.monthDrafts?.map((monthDraft) => {
      let mDraft = monthDraft.dayDrafts?.find((dayDraft) => {
        return dayDraft.templateRosterId === item.templateRosterId;
      });
      if (mDraft) {
        mDraft.checked = !item.checked;
      }
      return monthDraft;
    });
    const index = publishDialog.summaryInfo.selectedTemplateRosterIds?.findIndex((templateRosterId) => {
      return templateRosterId === item.templateRosterId;
    });
    if (index !== -1) {
      publishDialog.summaryInfo.selectedTemplateRosterIds.splice(index, 1);
      setSelectAll(false);
    } else {
      publishDialog.summaryInfo.selectedTemplateRosterIds.push(item.templateRosterId);
    }
    setPublishDialog({ ...publishDialog });
  };

  const handlePrePublish = useCallback(() => {
    (async () => {
      try {
        if (await checkVersion(true)) {
          setPublishOpen(true);
        } else {
          setPublishPopup(true);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [checkVersion]);

  const handlePublishPopup = (props) => () => {
    setPublishOpen(props);
  };

  const handleSavePopup = (props) => () => {
    setSavePopup(props);
  };

  const closePublishPopup = () => {
    setPublishPopup(false);
  };

  return (
    <DutyContext.Provider
      value={{ rosterId, isSort: publishInfo?.isSort, setPublishInfo, isRosterName, getIsRosterNameDetail}}
    >
      <div className={classes.root}>
        {alertInfo && (
          <Alert
            open={alertInfo.open}
            id="DutyAssign-Alert-aib"
            onClose={closeAlertInfo}
            text={alertInfo.text}
            type={alertInfo.type}
          />
        )}
        <Prompt
          when={editFlag}
          message={JSON.stringify({
            header: i18n.t('DUTYASSIGN_NOT_SAVE_TITLE'),
            content: i18n.t('DUTYASSIGN_NOT_SAVE_BODY'),
          })}
        />
        {clockConfirmOpen ? (
          <DiaLog
            open={clockConfirmOpen}
            id="DutyAssign-DiaLog-aik"
            cancel={i18n.t('DUTYASSIGN_CANCEL')}
            confirm={i18n.t('DUTYASSIGN_CONFIRM')}
            title={i18n.t('DUTYASSIGN_ROSTER_COPY_INFO')}
            handleCancel={() => {
              setClockConfirmOpen(false);
            }}
            handleClose={() => {
              setClockConfirmOpen(false);
            }}
            handleConfirm={() => {
              clockAPI(
                clockInfo?.clockInTime,
                clockInfo?.clockOutTime,
                clockInfo?.corpId,
                clockInfo?.tempId,
                clockInfo?.staffName
              );
              setClockConfirmOpen(false);
            }}
          >
            <div className={classes.publishBody}>
              {clockInfo?.clockOutTime === null
                ? i18n.t('DUTYASSIGN_ROSTER_VIEW_ROSTER_CONFIRM_CLOCK_IN', { value: clockInfo?.staffName })
                : i18n.t('DUTYASSIGN_ROSTER_VIEW_ROSTER_CONFIRM_CLOCK_OUT', { value: clockInfo?.staffName })}
            </div>
          </DiaLog>
        ) : null}
        {hasLinkedChatroomDeleted && (
          <DiaLog
            open={hasLinkedChatroomDeleted}
            title={i18n.t('DUTYASSIGN_TEAMDETAILS_DELETE_TIPS_TITLE')}
            confirm={i18n.t('EQUIPMENT_CONFIRM_OK')}
            handleCancel={() => {
              setHasLinkedChatroomDeleted(false);
            }}
            handleClose={() => {
              setHasLinkedChatroomDeleted(false);
            }}
            handleConfirm={() => {
              setHasLinkedChatroomDeleted(false);
            }}
          >
            <div
              style={{
                color: '#2e4469',
                fontSize: '1.25rem',
                fontFamily: 'NotoSans-Medium',
                fontWeight: 500,
                lineHeight: '1.875rem',
              }}
            >
              {i18n.t('DUTYASSIGN_TEAMDETAILS_DELETE_TIPS_CONTENT')}
            </div>
          </DiaLog>
        )}
        {publishDialogConfirmOpen ? (
          <DiaLog
            open={publishDialogConfirmOpen}
            id="DutyAssign-DiaLog-aik"
            cancel={i18n.t('DUTYASSIGN_CANCEL')}
            confirm={i18n.t('DUTYASSIGN_CONFIRM')}
            title={i18n.t('DUTYASSIGN_PUBLISH_DIALOG_TITLE')}
            handleCancel={() => {
              setPublishDialogConfirmOpen(false);
            }}
            handleClose={() => {
              setPublishDialogConfirmOpen(false);
            }}
            handleConfirm={handlePublishDialogConfirmButtonClick}
          >
            <div className={classes.publishBody}>{i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD_DIALOG_BODY')}</div>
          </DiaLog>
        ) : null}
        {publishDialog.open ? (
          <DiaLog
            open={publishDialog.open}
            title={`${i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD')}`}
            cancel={i18n.t('DUTYASSIGN_CANCEL')}
            confirm={i18n.t('DUTYASSIGN_CONFIRM')}
            handleCancel={handlePublishDialogClose}
            handleClose={handlePublishDialogClose}
            cancelID="DutyAssign-Dialog-period-cancel"
            confirmID="DutyAssign-Dialog-period-confirm"
            closeID="DutyAssign-Dialog-period-close"
            handleConfirm={() => {
              setPublishDialogConfirmOpen(true);
            }}
            disabled={confirmDisabled}
            dialogheadStyle={{ marginBottom: 0 }}
          >
            <div
              className="publish-dialog-roster-name"
              id="publish-by-period-roster-name"
              style={{ marginBottom: '1.75rem' }}
            >
              <span style={{ color: 'currentColor', fontSize: '1.025rem' }}>{publishDialog.rosterName}</span>
            </div>
            <div className="publish-dialog-publish-period-content">
              <div className="publish-dialog-period-date" style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, paddingRight: '.5rem' }}>
                  <KeyboardDatePicker
                    type="dialog"
                    size="small"
                    keyboardIcon={<DateIcon className={classes.Picon} />}
                    value={publishDialog.dateFrom}
                    onChange={(event) => {
                      publishDialog.dateFrom = event;
                      setEndMinDate(moment(event).format('YYYY-MM-DD'));
                      setEndMaxDate(moment(event).add(2, 'months').endOf('month').format('YYYY-MM-DD'));
                      setPublishDialog({ ...publishDialog });
                    }}
                    id="publish-dialog-datepicker-type-period-date-from"
                    variant="dialog"
                    format="DD-MM-yyyy"
                    inputVariant="outlined"
                    InputAdornmentProps={{
                      position: 'end',
                      id: 'publish-dialog-datepicker-type-period-date-from-button',
                    }}
                    placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_START_INPUT')}
                    minDate={startMinDate}
                  />
                </div>
                <div style={{ flex: 1, paddingRight: '.5rem' }}>
                  <KeyboardDatePicker
                    type="dialog"
                    size="small"
                    keyboardIcon={<DateIcon className={classes.Picon} />}
                    value={publishDialog.dateTo}
                    onChange={(event) => {
                      publishDialog.dateTo = event;
                      setPublishDialog({ ...publishDialog });
                    }}
                    id="publish-dialog-datepicker-type-period-date-to"
                    variant="dialog"
                    format="DD-MM-yyyy"
                    inputVariant="outlined"
                    InputAdornmentProps={{
                      position: 'end',
                      id: 'publish-dialog-datepicker-type-period-date-to-button',
                    }}
                    placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_END_INPUT')}
                    minDate={endMinDate}
                    maxDate={endMaxDate}
                    maxDateMessage={i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD_WITHIN_LATEST')}
                    minDateMessage={i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD_CAN_NOT_EARLIER')}
                  />
                </div>
                <div className="search-button">
                  <Button
                    id="publish-by-period-search-button"
                    className={classes.searchButton}
                    disabled={searchDisabled}
                    onClick={() => {
                      const dstart = new Date(publishDialog.dateFrom);
                      dstart.setHours(0, 0, 0, 0);
                      const payload = {
                        from: dstart.getTime(),
                        to: new Date(publishDialog.dateTo).getTime(),
                        rosterName: publishDialog.summaryInfo.rosterName,
                      };
                      dutyAssignAPI.listDraftSummary(payload).then((res) => {
                        const summaryInfo = res.result.summaryInfo;
                        setPublishDialog({
                          ...publishDialog,
                          summaryInfo,
                        });
                      });
                    }}
                  >
                    {i18n.t('DUTYASSIGN_ROSTER_SEARCH')}
                  </Button>
                </div>
              </div>
              {publishDialog.summaryInfo.monthDrafts?.length > 0 && (
                <div className="publish-dialog-dates-select-all" style={{ marginTop: '.5rem' }}>
                  <FormControlLabel
                    id="publish-by-period-select-all"
                    control={
                      <Checkbox
                        id="publish-by-period-select-all-checkbox"
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label={i18n.t('BEDSTATUS_SELECT_ALL')}
                  />
                </div>
              )}
              {publishDialog.summaryInfo.monthDrafts?.length === 0 && (
                <div
                  className="publish-dialog-dates-no-draft"
                  id="publish-by-period-no-draft"
                  style={{ marginTop: '1.5rem', marginLeft: '0.5rem' }}
                >
                  <span style={{ color: '#7d86a9', fontSize: '1rem' }} id="publish-by-period-no-draft-text">
                    {i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD_NO_DRAFT')}
                  </span>
                </div>
              )}

              <div className="publish-dialog-dates-list" style={{ marginTop: '.5rem' }}>
                <CustomAccordion
                  expandAll
                  itemClick={handleDayItemClick}
                  list={publishDialog.summaryInfo.monthDrafts?.map((monthDraft) => {
                    const days = monthDraft.dayDrafts?.map((dayDraft) => {
                      const dayItem = {
                        value: dayDraft.startMonthDay,
                        edited: dayDraft.edited,
                        templateRosterId: dayDraft.templateRosterId,
                        checked: dayDraft.checked === undefined ? true : dayDraft.checked,
                      };
                      return dayItem;
                    });
                    const group = {
                      date: monthDraft.monthName,
                      days,
                    };
                    return group;
                  })}
                />
              </div>
            </div>
            {publishDialog.summaryInfo.monthDrafts?.length !== 0 && (
              <div className={classes.infoMessageView}>
                <div className={classes.messageItem}>
                  <div id="publish-by-period-not-blue-button" className={classes.blueItem} />
                  <div id="publish-by-period-not-published-text" className={classes.messageText}>
                    {i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD_DRAFT_NOT_PUBLISHED')}
                  </div>
                </div>
                <div
                  className={classes.messageItem}
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <div id="publish-by-period-had-blue-button" className={classes.blueItem}>
                    <div id="publish-by-period-published-red-corner" className={classes.redCorner} />
                  </div>
                  <div id="publish-by-period-had-published-text" className={classes.messageText}>
                    {i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD_DRAFT_HAD_PUBLISHED')}
                  </div>
                </div>
              </div>
            )}
          </DiaLog>
        ) : null}
        <Header
          isLogin={isLogin}
          setUpLogin={setUpLogin}
          wardId={wardId}
          hospitalId={hospitalId}
          history={history}
          notifyOpen={notifyOpen}
          rosterId={rosterId}
          setRosterId={setRosterId}
          id="DutyAssign-Header-aic"
          setNotifyOpen={setNotifyOpen}
          updateDutyAPI={updateDutyAPI}
          handleSave={handleSave}
          getExportAPI={getExportAPI}
          getNotifyStaffAPI={getNotifyStaffAPI}
          notifyList={notifyList}
          pushNotifyStaffAPI={pushNotifyStaffAPI}
          getDutyListAPI={getDutyListAPI}
          setAlertInfo={setAlertInfo}
          dutyInfo={dutyInfo}
          staffsList={staffList}
          getResetDutyAPI={getResetDutyAPI}
          handleEdit={handleEdit}
          publishCtrl={publishCtrl}
          setDutyInfo={setDutyInfo}
          initDutyInfo={initDutyInfo}
          appendNoteList={(newNoteList = []) => {
            const mergeNoteList = newNoteList.concat(noteList);
            setNoteList(mergeNoteList);
          }}
          getFootNoteAPI={getFootNoteAPI}
          enableSmartComm={hasDutyChatValue?hasDutyChatValue:enableSmartComm}
          hasDutyChat={hasDutyChatValue}
        />
        <DragDropContext onDragEnd={handleDragEnd}>
          <div
            style={{
              overflow: 'auto',
              height: '100%',
            }}
          >
            {hiddenRoster || rosterId === -1 || dutyInfo === null || JSON.stringify(dutyInfo) === '{}' ? (
              <div className={classes.rosterBody}>
                <img className={classes.rosterPng} src={dt_roster} alt="duty assign" />
                <div className={classes.rosterContent}>{i18n.t('DUTYASSIGN_ROSTER_PROMPT')}</div>
              </div>
            ) : (
              <div className={classes.body} style={{ paddingRight: userInfo.flag ? '20rem' : '0rem' }}>
                {publishCtrl && (
                  <div className={classes.head}>
                    <div className={classes.savedAlert}>{editCW}</div>
                    <div style={{ display: 'flex' }}>
                      {publishCtrl && (
                        <ButtonBase
                          className={classes.headButton}
                          onClick={handlePreSave}
                          id="DutyAssign-ButtonBase-aid"
                        >
                          <SaveIcon className={classes.saveIcon} /> {i18n.t('DUTYASSIGN_SAVE')}
                        </ButtonBase>
                      )}
                      {publishCtrl && (
                        <ButtonBase
                          className={classes.headButton}
                          style={{ width: '7.5rem', marginLeft: '.7rem' }}
                          onClick={handlePrePublish}
                          id="DutyAssign-ButtonBase-aie"
                        >
                          <PublishIcon className={classes.publishIcon} /> {i18n.t('DUTYASSIGN_PUBLISH')}
                        </ButtonBase>
                      )}
                      {publishCtrl && (
                        <ButtonBase
                          className={classes.batchPublishButton}
                          style={{ marginLeft: '.7rem' }}
                          onClick={handlePrePublishByPeriod}
                          id="DutyAssign-ButtonBase-publish-by-period"
                        >
                          <PublishIcon className={classes.publishIcon} /> {i18n.t('DUTYASSIGN_PUBLISH_BY_PERIOD')}
                        </ButtonBase>
                      )}
                    </div>
                  </div>
                )}
                {Array.isArray(dutyInfo.dutyGroups) &&
                  dutyInfo.dutyGroups.map((item) => {
                    switch (item.groupType) {
                      case 1:
                        return (
                          <DutyIC
                            key={item.dutyTemplateGroupId}
                            list={item.dutyAreas}
                            setDutyICList={handleEditDuty(item.dutyTemplateGroupId)}
                            publishCtrl={publishCtrl}
                            head={!item.isHide && item.groupName}
                            handleEdit={handleEdit}
                          />
                        );
                      case 2:
                        return (
                          <OnDuty
                            key={item.dutyTemplateGroupId}
                            ondutyList={item.dutyAreas}
                            setOndutyList={handleEditDuty(item.dutyTemplateGroupId)}
                            staffList={staffList}
                            publishCtrl={publishCtrl}
                            head={!item.isHide && item.groupName}
                            handleEdit={handleEdit}
                            setAlertInfo={setAlertInfo}
                            dutyTemplateGroupId={item.dutyTemplateGroupId}
                            dutyCheckList={dutyCheckList}
                            enableSmartComm={hasDutyChatValue?hasDutyChatValue:enableSmartComm}
                          />
                        );
                      case 3:
                        return (
                          <Leave
                            key={item.dutyTemplateGroupId}
                            ondutyList={item.dutyAreas}
                            setOndutyList={handleEditDuty(item.dutyTemplateGroupId)}
                            staffList={staffList}
                            publishCtrl={publishCtrl}
                            head={!item.isHide && item.groupName}
                            handleEdit={handleEdit}
                            setAlertInfo={setAlertInfo}
                            dutyTemplateGroupId={item.dutyTemplateGroupId}
                            enableSmartComm={hasDutyChatValue?hasDutyChatValue:enableSmartComm}
                          />
                        );
                      default:
                        return null;
                    }
                  })}
                <Footnote
                  publishCtrl={publishCtrl}
                  list={note}
                  templateRosterId={rosterId}
                  noteList={noteList}
                  getFootNoteAPI={getFootNoteAPI}
                  id="DutyAssign-Footnote-aii"
                  setNoteList={setNoteList}
                  handleReOrderFootNoteAPI={handleReOrderFootNoteAPI}
                />
              </div>
            )}
          </div>
          {userInfo.flag && (
            <DutyRoster
              wardId={wardId}
              list={staffsList}
              setList={setStaffsList}
              rosterId={rosterId}
              id="DutyAssign-DutyRoster-aij"
              publishCtrl={publishCtrl}
              getStaffListAPI={getStaffListAPI}
              rouList={rouList}
              rosterData={rosterData}
              setrosterRefresh={setrosterRefresh}
              getDutyListAPI={getDutyListAPI}
              smartComm={hasDutyChatValue?hasDutyChatValue:enableSmartComm}
            />
          )}
        </DragDropContext>
        <DiaLog
          open={publishOpen}
          id="DutyAssign-DiaLog-aik"
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          title={i18n.t('DUTYASSIGN_PUBLISH_DIALOG_TITLE')}
          handleCancel={handlePublishPopup(false)}
          handleClose={handlePublishPopup(false)}
          handleConfirm={updateDutyAPI}
        >
          <div className={classes.publishBody}>{i18n.t('DUTYASSIGN_PUBLISH_DIALOG_BODY')}</div>
        </DiaLog>
        {savePopup && (
          <DiaLog
            open={true}
            title={i18n.t('DUTY_ASSIGN_SAVE_DRAFT_POPUP_TITLE')}
            cancel={i18n.t('DUTY_ASSIGN_SAVE_DRAFT_POPUP_LEFT_BUTTON')}
            confirm={i18n.t('DUTY_ASSIGN_SAVE_DRAFT_POPUP_RIGHT_BUTTON')}
            handleCancel={getDutyListAPI}
            handleClose={handleSavePopup(false)}
            handleConfirm={handleOverride}
          >
            <div
              className={classes.publishBody}
              dangerouslySetInnerHTML={{
                __html: i18n.t('DUTY_ASSIGN_SAVE_DRAFT_POPUP_CONTENT', { name: lastEditor }),
              }}
            />
          </DiaLog>
        )}
        {publishPopup && (
          <DiaLog
            open={true}
            title={i18n.t('DUTY_ASSIGN_SAVE_DRAFT_POPUP_TITLE')}
            cancel={i18n.t('DUTY_ASSIGN_SAVE_DRAFT_POPUP_LEFT_BUTTON')}
            confirm={i18n.t('DUTY_ASSIGN_SAVE_DRAFT_POPUP_RIGHT_BUTTON')}
            handleCancel={getDutyListAPI}
            handleClose={closePublishPopup}
            handleConfirm={updateDutyAPI}
          >
            <div
              className={classes.publishBody}
              dangerouslySetInnerHTML={{ __html: i18n.t('DUTY_ASSIGN_PUBLISH_POPUP_CONTENT', { name: lastEditor }) }}
            />
          </DiaLog>
        )}
      </div>
      <VerifyAccountPop
        open={Boolean(vertifyInfo)}
        id="DutyAssign-VerifyAccountPop-abs"
        onClose={() => {
          setVertifyInfo(false);
        }}
        corpId={vertifyInfo.corpId}
        successHandle={() => {
          const { status, corpId, tempId, staffName } = vertifyInfo;
          (async () => {
            doClock(status, corpId, tempId, staffName);
          })();
          setVertifyInfo(false);
        }}
        failHandle={() => {
          alertMsg(i18n.t('DUTYASSIGN_ATTENDANCE_VERTIFY_FAIL'), _.uniqueId('warning_'), 'warning');
        }}
      />
    </DutyContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  loginInfo: state.loginInfo,
  wardId: state.loginInfo.wardId,
  hospitalId: state.loginInfo.hospitalId,
  userRole: state.userRole,
  rouList: state.rouList,
  roleMap: state.roleMap,
  editFlag: state.dutyEditFlag,
});

const mapDispatchToProps = (dispatch) => ({
  setUpLogin: ({ isLogin, ...reset }) => {
    dispatch(updateLoginInfoAction({ flag: isLogin, ...reset }));
  },
  setEdit: () => {
    dispatch(SetEdit());
  },
  setUnEdit: () => {
    dispatch(SetUnEdit());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DutyAssign);


// 格式化更表
const initDutyInfo = (dutyInfo) => {
  if (!dutyInfo || JSON.stringify(dutyInfo) === '{}') {
    return dutyInfo;
  }

 
  return {
    ...dutyInfo,
    dutyGroups: _.orderBy(
      _.map(dutyInfo.dutyGroups, (item) => {
        switch (item.groupType) {
          case 1:
            return {
              ...item,
              dutyAreas: _.orderBy(initDutyIC(item.dutyAreas), ['areaOrder'], ['asc']),
            };
          case 2:
          case 3:
            return {
              ...item,
              dutyAreas: _.orderBy(initOnDutyAndLeave(item.dutyAreas), ['areaOrder'], ['asc']),
            };
          default:
            return item;
        }
      }),
      ['groupOrder'],
      ['asc']
    ),
  };
};

// 格式化 Duty Ic 的数据
const initDutyIC = (dutyAreas) => {
  return _.map(_.orderBy(dutyAreas, 'areaOrder'), (item, index) => {
    let list = JSON.parse(localStorage.getItem('dutyIC'));

    if (!list || Array.isArray(list)) {
      list = {};
    }

    let dutyStaffs = Array.isArray(item.dutyStaffs) ? item.dutyStaffs : [];
    const areaName=item.areaName ?? item.functionalAreaName;

    // 如果没有duty staff，则从localstorage里读取相同的functionalAreaName的staff，如果也没有，则设置为空值
    if (dutyStaffs.length === 0) {
      dutyStaffs = list?.[areaName]
        ? [list[areaName]]
        : [
            {
              name: null,
              status: 1,
              longRemark: null,
              shortRemark: null,
              colour: 'White',
            },
          ];
    }

    return {
      ...item,
      id: item.dutyFunctionalAreaId ?? item.dutyTemplateFunctionalAreaId,
      title: item.areaName ?? item.functionalAreaName,
      dutyStaffs,
    };
  });
};

// 格式化 OnDuty && Leave的数据
const initOnDutyAndLeave = (dutyAreas) => {
  return _.map(dutyAreas, (item) => ({
    ...item,
    id: item.dutyFunctionalAreaId ?? item.dutyTemplateFunctionalAreaId,
    title: item.areaName ?? item.functionalAreaName,
    height: item.height,
    dutyStaffs: _.orderBy(
      _.map(item.dutyStaffs, (staff) => {
        return {
          ...staff,
          id: staff.corpId ?? staff.tempId ?? staff.name,
          name: staff.name,
          remark: staff.shortRemark,
          longremark: staff.longRemark,
          rankCode: staff.rankCode ?? null,
          role: staff.role ?? null,
          color: staff.colour,
          outlineColour: (staff.role && handleStaffColor({ role: staff.role })) ?? 0,
          rankOrder: staff.rankOrder ?? null,
          Rinfo: {
            corpId: staff.corpId,
            empId: staff.emp_id,
            staffName: staff.staff_name,
            tempUserId: staff.tempId,
          },
        };
      }),
      ['staffOrder'],
      ['asc']
    ),
  }));
};

const handleUpdate = (item, index) => {
  let staffList = [];
  staffList = _.map(item.dutyStaffs, (staff, staffIndex) => {
    return {
      corpId: staff.corpId ?? null,
      tempId: staff.tempId ?? null,
      colour: staff.color ?? 'White',
      longRemark: staff.longremark ?? null,
      rankCode: staff.rankCode ?? null,
      role: staff.role ?? null,
      name: staff.name,
      shortRemark: staff.remark ?? null,
      staffOrder: staffIndex + 1,
      status: staff.status ?? 1,
      dutyFunctionalAreaStaffId: staff.dutyFunctionalAreaStaffId ?? null,
      rankOrder: staff.rankOrder ?? null,
      dutyEndAt: staff.dutyEndAt,
      dutyStartAt: staff.dutyStartAt,
    };
  });
  return {
    dutyFunctionalAreaId: item.dutyFunctionalAreaId ?? null,
    dutyTemplateFunctionalAreaId: item.dutyTemplateFunctionalAreaId ?? null,
    areaOrder: index + 1,
    areaName: item.title,
    height: item.height,
    dutyStaffs: staffList,
    chatBufferEnterAt: item.chatBufferEnterAt,
    chatBufferLeaveAt: item.chatBufferLeaveAt,
    chatEndAt: item.chatEndAt,
    chatStartAt: item.chatStartAt,
    dutyChats: item.dutyChats,
    bodyBackgroundColor: item.bodyBackgroundColor,
    bsTeamType: item.bsTeamType,
    bsVisible: item.bsVisible,
  };
};

const handleDragStaff = ({ item, sourceStaff, rankOrder }) => {
  if (String(item.id) === String(sourceStaff.id)) {
    return {
      ...sourceStaff,
      rankOrder: sourceStaff.rankOrder ? sourceStaff.rankOrder : rankOrder,
      dutyEndAt:
        sourceStaff.dutyEndAt !== null && sourceStaff.dutyEndAt !== '' && sourceStaff.dutyEndAt !== undefined
          ? sourceStaff.dutyEndAt
          : null,
      dutyStartAt:
        sourceStaff.dutyStartAt !== null && sourceStaff.dutyStartAt !== '' && sourceStaff.dutyStartAt !== undefined
          ? sourceStaff.dutyStartAt
          : null,
      remark: sourceStaff.shortRemark,
      longremark: sourceStaff.longRemark,
    };
  } else {
    return item;
  }
};
// 拖拽到相应的位置后放下
const handleOrder = ({ item, dutyList, source }) => {
  if (!item.destination) return;
  const items = Array.from(dutyList);
  items.splice(item.destination.index, 0, source);
  return items;
};

const dragFromRoster = (e, setDutyInfo, rosterData, handleEdit, rankOrderMap) => {
  let sourceStaff = _.find(rosterData, (item) => String(item.id) === String(e.draggableId));
  const destination = JSON.parse(e.destination.droppableId);
  const rankOrder = rankOrderMap[sourceStaff.rank_code];
  setDutyInfo((preDutyInfo) => {
    return {
      ...preDutyInfo,
      dutyGroups: _.map(preDutyInfo.dutyGroups, (item) =>
        // 通过dutyTemplateGroupId找出当前group
        item.dutyTemplateGroupId === destination.dutyTemplateGroupId
          ? {
              ...item,
              // 通过listIndex找出当前cubicle
              dutyAreas: _.map(item.dutyAreas, (dutyAreasItem, dutyAreasIndex) =>
                dutyAreasIndex === destination.listIndex
                  ? {
                      ...dutyAreasItem,
                      // 定位到对应的cubicle之后，再判断是否已经存在当前staff！！
                      dutyStaffs: _.some(
                        dutyAreasItem.dutyStaffs,
                        (staffItem) => String(staffItem.id) === String(e.draggableId)
                      )
                        ? _.map(dutyAreasItem.dutyStaffs, (staffItem) =>
                            handleDragStaff({ item: staffItem, sourceStaff })
                          )
                        : handleOrder({
                            item: e,
                            dutyList: dutyAreasItem.dutyStaffs,
                            source: {
                              ...sourceStaff,
                              rankOrder: sourceStaff.rankOrder ? sourceStaff.rankOrder : rankOrder,
                              dutyEndAt:
                                sourceStaff.dutyEndAt !== null &&
                                sourceStaff.dutyEndAt !== '' &&
                                sourceStaff.dutyEndAt !== undefined
                                  ? sourceStaff.dutyEndAt
                                  : null,
                              dutyStartAt:
                                sourceStaff.dutyStartAt !== null &&
                                sourceStaff.dutyStartAt !== '' &&
                                sourceStaff.dutyStartAt !== undefined
                                  ? sourceStaff.dutyStartAt
                                  : null,
                              remark: sourceStaff.shortRemark,
                              longremark: sourceStaff.longRemark,
                            },
                          }),
                    }
                  : dutyAreasItem
              ),
            }
          : item
      ),
    };
  });
  handleEdit();
};

// 检查cubicle里面是否已经存在当前staff!!
const checkStaff = (dutyInfo, destination, e, draggableId) => {
  const dutyGroup = _.find(dutyInfo.dutyGroups, (item) => item.dutyTemplateGroupId === destination.dutyTemplateGroupId);

  if (dutyGroup) {
    const cubicle = _.find(dutyGroup.dutyAreas, (_item, index) => index === destination.listIndex);
    if (cubicle) {
      return _.some(cubicle.dutyStaffs, (item) => String(item.id) === String(draggableId));
    }
    return false;
  }
  return false;
};

// 获取当前拖拽的staff信息
const getStaffFormCubicle = (dutyInfo, source, e, draggableId) => {
  const dutyGroup = _.find(dutyInfo.dutyGroups, (item) => item.dutyTemplateGroupId === source.dutyTemplateGroupId);
  const cubicle = _.find(dutyGroup.dutyAreas, (_item, index) => index === source.listIndex);
  return _.find(cubicle.dutyStaffs, (item) => String(item.id) === String(draggableId));
};

// 同一个数组里交换两个元素的位置
function reOrder(array, sourceIndex, destinationIndex) {
  let clonedArray = _.cloneDeep(array);
  const staff = clonedArray[sourceIndex];
  clonedArray.splice(sourceIndex, 1);
  clonedArray.splice(destinationIndex, 0, staff);
  return clonedArray;
}

// 从cubicle之间拖拽staff
const dragFromCubicle = (e, setDutyInfo, handleEdit) => {
  const destination = JSON.parse(e.destination.droppableId);
  const source = JSON.parse(e.source.droppableId);
  const draggableId =
    e.draggableId.search('___') > -1 ? e.draggableId.slice(e.draggableId.search('___') + 3) : e.draggableId;
  setDutyInfo((preDutyInfo) => {
    if (checkStaff(preDutyInfo, destination, e, draggableId)) {
      handleEdit();
      return {
        ...preDutyInfo,
        dutyGroups: _.map(preDutyInfo.dutyGroups, (item) => ({
          ...item,
          dutyAreas: _.map(item.dutyAreas, (dutyAreasItem, dutyAreasIndex) => {
            if (item.dutyTemplateGroupId === source.dutyTemplateGroupId && dutyAreasIndex === source.listIndex) {
              // 同一个group里拖拽
              return {
                ...dutyAreasItem,
                dutyStaffs: reOrder(dutyAreasItem.dutyStaffs, e.source.index, e.destination.index),
              };
            }
            // 其余的不变
            return dutyAreasItem;
          }),
        })),
      };
    } else {
      const sourceStaff = getStaffFormCubicle(preDutyInfo, source, e, draggableId);
      handleEdit();
      return {
        ...preDutyInfo,
        dutyGroups: _.map(preDutyInfo.dutyGroups, (item) => ({
          ...item,
          dutyAreas: _.map(item.dutyAreas, (dutyAreasItem, dutyAreasIndex) => {
            if (item.dutyTemplateGroupId === source.dutyTemplateGroupId && dutyAreasIndex === source.listIndex) {
              // 被拖拽的cubicle需要移除staff
              return {
                ...dutyAreasItem,
                dutyStaffs: _.filter(
                  dutyAreasItem.dutyStaffs,
                  (staffItem) => String(staffItem.id) !== String(draggableId)
                ),
              };
            } else if (
              item.dutyTemplateGroupId === destination.dutyTemplateGroupId &&
              dutyAreasIndex === destination.listIndex
            ) {
              // 放下的cubicle添加staff
              return {
                ...dutyAreasItem,
                dutyStaffs: handleOrder({ item: e, dutyList: dutyAreasItem.dutyStaffs, source: sourceStaff }),
              };
            }
            // 其余的不变
            return dutyAreasItem;
          }),
        })),
      };
    }
  });
};
